module.exports = __webpack_public_path__ + "img/Looc_halo.e72bf045.png";